module.exports = global["MobileDetect"] = require("-!./mobile-detect.js");


//////////////////
// WEBPACK FOOTER
// ./~/mobile-detect/mobile-detect.js
// module id = 553
// module chunks = 0